import React, { useEffect, useState } from "react";
import {
  Container,
  Row
} from "react-bootstrap";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// import required modules
import "../css/home.css";
import { getcmsAction } from "../../../Action/user.action";

const Amlpolicy = () => {
  const [amlpolicy, setamlpolicy] = useState({
    aml_policy:""
  });
  useEffect(() => {
    AmlPolicyFun();
    // setcondition();
  }, []);

  const AmlPolicyFun = async () => {
    let res = await getcmsAction("amlpolicy");
    if (res.success) {
      setamlpolicy(res.data);
    } else {
    }
  };

  // const navigateToPackagePlan = () => {

  //   navigate(`${config.baseUrl}packageplan`)
  // }

  return (
    <>
      <div className="lighttheme overflow-hidden hero" >
        <section className="herobanner position-relative text-white overflow-hidden" style={{backgroundColor:"black"}}>
          <Container>
            <Row className="align-items-center">
              <div className="jovitClass"
                dangerouslySetInnerHTML={{
                  __html: amlpolicy.aml_policy,
                }}
              />
            </Row>
          </Container>
        </section>
      </div>

      
    </>
  );
};
export default Amlpolicy;
